import { fromJS } from 'immutable'
import 'isomorphic-fetch'

import { serialize } from 'utils/helpers'

const API = process.env.REACT_APP_API
const AUTH = process.env.REACT_APP_AUTH

const request = () => fromJS({
  headers: { 'Content-Type': 'application/json' },
})

const apiRequest = () => {
  const req = request()
  return req.setIn(['headers', 'Authorization'], 'Bearer ' + localStorage.getItem('token:jwt'))
}

export const authenticate = (credentials) => {
  const req = {
    endpoint: AUTH + '/login',
    method: 'POST',
    body: JSON.stringify(credentials),
  }

  return request().merge(fromJS(req)).toJS()
}

export const changeSem = (pl) => {
  const session = JSON.parse(localStorage.getItem('session'))
  const payload = {
    user_id: Number(localStorage.getItem('token:user_id')),
    campus_id: Number(session.campus_id),
    rft: localStorage.getItem('token:rft'),
    remember: localStorage.getItem('token:remember') === 'true',
    sy: pl.get('sy'),
    sem: pl.get('sem'),
  }

  const req = {
    endpoint: AUTH + '/change-semester',
    method: 'POST',
    body: JSON.stringify(payload),
  }

  return request().merge(fromJS(req)).toJS()
}

export const logout = () => {
  const req = {
    endpoint: AUTH + '/logout',
    method: 'POST',
    body: JSON.stringify({ rft: localStorage.getItem('token:rft') }),
  }

  return apiRequest().merge(fromJS(req)).toJS()
}

export const delegate = () => {
  const session = JSON.parse(localStorage.getItem('session'))
  const body = {
    user_id: Number(localStorage.getItem('token:user_id')),
    rft: localStorage.getItem('token:rft'),
    remember: localStorage.getItem('token:remember') === 'true',
    campus_id: Number(session.campus_id),
    semcamp_id: Number(session.semcamp_id),
  }
  const req = {
    endpoint: AUTH + '/delegate',
    method: 'POST',
    body: JSON.stringify(body),
  }

  return request().merge(fromJS(req)).toJS()
}

export const get = (ep, query) => {
  const que = serialize(query) || ''
  if (que) {
    ep = ep + '?' + que
  }
  const req = {
    endpoint: API + ep,
    method: 'GET',
  }

  return apiRequest().merge(fromJS(req)).toJS()
}

export const post = (ep, payload) => {
  const req = {
    endpoint: API + ep,
    method: 'POST',
    body: JSON.stringify(payload),
  }

  return apiRequest().merge(fromJS(req)).toJS()
}

export const put = (ep, payload) => {
  const req = {
    endpoint: API + ep,
    method: 'PUT',
    body: JSON.stringify(payload),
  }

  return apiRequest().merge(fromJS(req)).toJS()
}

export const destroy = (ep, payload) => {
  const req = {
    endpoint: API + ep,
    method: 'DELETE',
    body: JSON.stringify(payload),
  }

  return apiRequest().merge(fromJS(req)).toJS()
}

export const download = (ep, query) => {
  const que = serialize(query) || ''
  if (que) {
    ep = ep + '?' + que
  }
  return new Promise((resolve, reject) => {
    fetch(API+ep, { headers: new Headers({
      'Authorization': 'Bearer ' + localStorage.getItem('token:jwt'),
    })}).then((res) => {
      return res.blob()
    }).then((blob) => {
      resolve(blob)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/network.js